import PrescriptionView from '@screens/vision/prescription/view'

export default function PrescriptionByIdPage() {
  return <PrescriptionView />
}
